import { useEffect } from "react";
import FooterContact from "../../FooterContactPage/FooterContact";
import QuickNav from "../../HomePage/HeroSection/QuickNav";
import MobileAppBanner from "../../HomePage/Services/mobileAppBanner";
import ServicesIndustries from "../../HomePage/Services/ServicesIndustries";
import AdvantagesBanner from "./AdvantagesBanner/AdvantagesBanner";
import AdvantagesList from "./AdvantagesList/AdvantagesList";
import { Helmet } from "react-helmet-async";

const AppDevelopment = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const QuickNavItems = ["Industry", "Advantages", "Form"];

  return (
    <div>
      <>
        <Helmet>
          <title>
            Mobile App Development Company in Bangladesh | Quad Theory Ltd
          </title>
          <meta
            name="description"
            content="Quad Theory Ltd is a mobile app development company in Bangladesh building reliable iOS and Android apps. Offshore teams, clear communication, and mobile apps designed for real world use."
          />
        </Helmet>
      </>
      <MobileAppBanner />
      <QuickNav items={QuickNavItems} />
      <ServicesIndustries></ServicesIndustries>
      <AdvantagesBanner />
      <AdvantagesList />
      <FooterContact />
    </div>
  );
};

export default AppDevelopment;
